import { render, staticRenderFns } from "./ProductsShow.vue?vue&type=template&id=3bd9d12c&scoped=true&"
import script from "./ProductsShow.vue?vue&type=script&lang=js&"
export * from "./ProductsShow.vue?vue&type=script&lang=js&"
import style0 from "./ProductsShow.vue?vue&type=style&index=0&id=3bd9d12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd9d12c",
  null
  
)

export default component.exports